import React from 'react';
import styled from 'styled-components';
import { useStoreState } from 'easy-peasy';

import { media } from '~/styles/Utils';

const Wrapper = styled.div`
  position: absolute;
  left: 6%;
  top: 70%;
  transform: translate(0, -100%);
  width: 120px;
  color: ${(p) => p.theme.colors.gray};

  ${media.m`
    top: 65%;
  `};
`;

const YearLabel = styled.span`
  color: ${(p) => p.theme.colors.highlight};
  font-weight: 700;
`;

const Text = ({ data }) => {
  const year = useStoreState((s) => s.app.year);
  const currData = data.find((d) => d.year === year);

  return (
    <Wrapper>
      <YearLabel>
        {Math.round(currData.taxIncome / 1000000000)} Milliarden Euro
      </YearLabel>{' '}
      Einnahmen aus Einkommensteuern im Jahr <YearLabel>{year}</YearLabel>
    </Wrapper>
  );
};

export default Text;
